(() => {
  const labels = document.getElementById('naninha-reviews-labels');
  const section = document.querySelector('footer [id$="__1789452644d212a1e6"]');
  if (!labels || !section || section.dataset.naninhaReviewsInitialized) return;
  section.dataset.naninhaReviewsInitialized = 'true';
  let expanded = false;
  let scheduled = false;
  const sync = () => {
    scheduled = false;
    const widget = section.querySelector('#vstar-reviews');
    const list = widget?.querySelector('.tt-review-list');
    if (!list) return;
    const count = list.querySelectorAll(':scope > .list-review').length;
    widget.dataset.naninhaCompact = String(!expanded && count > 3);
    let button = widget.querySelector('.naninha-reviews-toggle');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'naninha-reviews-toggle';
      button.setAttribute('aria-controls', 'naninha-home-review-list');
      button.addEventListener('click', () => {
        expanded = !expanded;
        sync();
      });
      widget.appendChild(button);
    }
    list.id = 'naninha-home-review-list';
    button.hidden = count <= 3;
    button.setAttribute('aria-expanded', String(expanded));
    const text = expanded ? labels.dataset.less : labels.dataset.more;
    if (button.textContent !== text) button.textContent = text;
  };
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  });
  observer.observe(section, {childList: true, subtree: true});
  sync();
})();
